import React, {useEffect} from 'react';
import {Helmet} from "react-helmet";
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
import {Actions as CREATEACCOUNTACTIONS} from '../store/actions/createAccountActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';
import PayrollGuideForm from '../components/common/PayrollGuideForm'
import PayrollGuideRequestRecieved from '../components/common/PayrollGuideRequestRecieved'
import FeaturesSideBySide from '../components/features/FeaturesSideBySide'
import MaltaFeatures from '../components/features/MaltaFeatures'
import Team from '../components/team/Team'
import Pricing from '../components/pricing/Pricing'
import Testimonials from '../components/testimonials/Testimonials'
import Security from '../components/security/Security'


import MaltaFlag from '../assets/flags/malta.svg';

const faqs = [
  {
    question: "What leave are my employees entitled to?",
    // answer:
      // "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },
  {
    question: "Do part-time employees get Public Holiday, Vacation and Sick Leave?",
    // answer:
      // "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },
  {
    question: "What is the Sickness Benefit?",
    // answer:
      // "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },
  {
    question: "How do I pay employees on Sick Leave?",
    // answer:
      // "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },
  {
    question: "How is the Sick Benefit Calculated?",
    // answer:
      // "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },
  {
    question: "What is COLA (Cost of Living Adjustment)?",
    // answer:
      // "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },
  {
    question: "What is a notice period?",
    // answer:
      // "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },
  {
    question: "What is a car cash allowance?",
    // answer:
      // "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },
  {
    question: "What is the overtime tax rate?",
    // answer:
      // "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },
  {
    question: "What Tax Rate should I use for my employees?",
    // answer:
      // "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },
  {
    question: "Do I have to pay Maternity Fund Contributions for all my employees?",
    // answer:
      // "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },
  {
    question: "What should a payslip include?",
    // answer:
      // "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas cupiditate laboriosam fugiat.",
  },
  // More questions...
]

function PayrollGuide({
  userInList,
  contactInList,
  profile
}) {

  useEffect(() => {
    // load initial data required for anywhere
    if (profile && profile.email){
      contactInList({
        email: profile.email,
        list: 10 // 5 is old list
      })
    }
  },[profile && profile.email]);

  return (

    <React.Fragment>
      <Helmet>
          <title>Malta's Payroll Guide | Buddy</title>
        <meta name="description" content="Find answers to the most frequently asked questions about payroll, including calculating payroll, employee leave, tax and benefits deductions." />
          <link rel="canonical" href={`https://www.buddy.hr/mt/payroll-guide`} />
      </Helmet>
      <main className="mt-8 sm:mt-16 md:mt-20 lg:mb-24 mb-8 sm:mb-16 md:mb-20 lg:mb-24">
        <div className="mx-auto max-w-screen-xl">
          <div className="lg:grid lg:grid-cols-12 lg:gap-8">
            <div className="px-4 sm:px-6 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-center">
              <div>
                {/*<Link to="covid-19" className="inline-flex items-center text-white bg-gray-900 rounded-full p-1 pr-2 sm:text-base lg:text-sm xl:text-base hover:text-gray-200">
                  <span className="px-3 py-0.5 text-white text-xs font-semibold leading-5 uppercase tracking-wide bg-orange-500 rounded-full">Covid-19 Support</span>
                  <span className="ml-4 text-sm leading-5">Click to learn more</span>
                  
                  <svg className="ml-2 w-5 h-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                  </svg>
                </Link>*/}
                <h1 className="mt-4 text-4xl tracking-tight leading-10 font-extrabold text-white sm:mt-5 sm:leading-none sm:text-6xl lg:mt-6 lg:text-5xl xl:text-6xl">
                  Malta's&nbsp;
                  <br className="hidden md:inline"/>
                  <span className="text-orange-400">Payroll Guide</span>
                </h1>
                { userInList && 
                  <>
                    <p className="mt-3 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                      Your Payroll Guide is on the way to your Inbox.
                    </p>

                    <div className="mt-6 prose prose-orange prose-lg text-gray-200 mx-auto">
                      <ul role="list">
                        <li>You've just taken an important step to further your payroll knowledge.</li>
                        <li>We have just sent you an email, with the payroll guide.</li>
                        <li>If you don't find it in your inbox, make sure to check your spam folder and whitelist Buddy.</li>
                      </ul>
                    </div>
                  </>
                }
                { !userInList && 
                  <>
                    <p className="mt-3 text-base text-gray-300 sm:mt-5 sm:text-xl lg:text-lg xl:text-xl">
                      Malta's only payroll guide that works with all payroll software.
                    </p>

                    <div className="mt-6 prose prose-orange prose-lg text-gray-200 mx-auto">
                      <ul role="list">
                        <li>Answers payroll <strong className="text-white">questions by Business Owners</strong> & HR Managers.</li>
                        <li><strong className="text-white">24 Pages</strong> of pure value. <span className='text-xs'>(guaranteed to save you €€€ in consulting fees)</span></li>
                        <li>Updated to include <strong className="text-white">2022 Budget Updates</strong>.</li>
                        {/*<li>Delivered <strong className="text-white">FREE</strong> to your door.</li>*/}
                      </ul>
                    </div>
                  </>
                }
                {/*<p className="mt-8 text-sm text-white uppercase tracking-wide font-semibold sm:mt-10">Used by</p>
                <div className="mt-5 w-full sm:mx-auto sm:max-w-lg lg:ml-0">
                  <div className="flex flex-wrap items-start justify-between">
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={mcDonaldsLogo} alt="Mc Donalds"/>
                    </div>
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={myokaLogo} alt="Myoka Spas"/>
                    </div>
                    <div className="flex justify-center px-1">
                      <img className="h-9 sm:h-10" src={skySpiritLogo} alt="Sky Spirit"/>
                    </div>
                  </div>
                </div>*/}
              </div>
            </div>
            <div className="mt-12 sm:mt-16 lg:mt-0 lg:col-span-6 px-5 sm:px-0">

              { userInList && <iframe style={{border: "1px solid #777", width: "448px", height:"464px"}} src="https://indd.adobe.com/embed/47e4b687-d024-4f03-b1f0-7995a21bba51?startpage=1&allowFullscreen=true" frameborder="0" allowfullscreen="true"></iframe>}
              
              { false && userInList && 
                <PayrollGuideRequestRecieved/>
              }

              { !userInList && <PayrollGuideForm/> } 
            </div>
          </div>
        </div>
      </main>

      <div className="py-12">
        <div className="max-w-xl mx-auto px-4 sm:px-6 lg:max-w-screen-xl lg:px-8">

          <div className="relative">
            <h3 className="text-center text-3xl leading-8 font-extrabold tracking-tight text-white sm:text-4xl sm:leading-10">
             { /*<img className="h-9 sm:h-10" src={MaltaFlag} alt="Mc Donalds"/> */}
              What's in the Payroll Guide
            </h3>
            <p className="mt-4 max-w-3xl mx-auto text-center text-xl leading-7 text-gray-300">
              A 24-page booklet containing answers to the most common payroll challenges
            </p>
          </div>

          <div className="lg:grid lg:grid-cols-3 lg:gap-8 relative mt-12 lg:mt-24 ">
            <div>
              <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                {/* Heroicon name: globe-alt */} 
                <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9m-9 9a9 9 0 019-9" />
                </svg>
              </div>
              <div className="mt-5">
                <h5 className="text-lg leading-6 font-medium text-white">Latest Updates</h5>
                <p className="mt-2 text-base leading-6 text-gray-300">
                  Vacation leave, parental leave and Cost of Living Adjustments as announced in the 2022 budget.
                </p>
              </div>
            </div>
            <div className="mt-10 lg:mt-0">
              <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                {/* Heroicon name: scale */} 
                <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
                </svg>
              </div>
              <div className="mt-5">
                <h5 className="text-lg leading-6 font-medium text-white">Taxes Explained</h5>
                <p className="mt-2 text-base leading-6 text-gray-300">
                  A guide through the applicable taxes in Malta, and how each option applies.
                </p>
              </div>
            </div>
            <div className="mt-10 lg:mt-0">
              <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
                {/* Heroicon name: lightning-bolt */} 
                <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <div className="mt-5">
                <h5 className="text-lg leading-6 font-medium text-white">Easy to Follow</h5>
                <p className="mt-2 text-base leading-6 text-gray-300">
                  We understand your time is prescious, this guide was crafted for the business owner and HR manager. No previous payroll experience required.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

        <div className="bg-white">
          <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8">
            <h2 className="text-3xl font-extrabold text-gray-900">Your Payroll Questions Answered</h2>
            <div className="mt-6 border-t border-gray-300 border-opacity-25 pt-10">
              <dl className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-12">
                {faqs.map((faq) => (
                  <div key={faq.id}>
                    <dt className="text-lg leading-6 font-medium text-gray-500">{faq.question}</dt>
                    {/*<dd className="mt-2 text-base text-orange-200">{faq.answer}</dd>*/}
                  </div>
                ))}
              </dl>
            </div>
            <h3 className="mt-8 text-2xl font-extrabold text-gray-900">Looking for Answers?</h3>
            <p className="mt-2 text-base leading-6 text-gray-500">Answers to these questions and many more can be found in the payroll guide. <br/>Mailed for Free to an address of your choice.</p>
          </div>
        </div>

        <div className="bg-orange-50">
          <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-24 lg:px-8 lg:flex lg:items-center lg:justify-between">
            <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 md:text-4xl">
              <span className="block">Want a Payroll Guide?</span>
              <span className="block text-orange-600">Get your FREE copy today.</span>
            </h2>
            <div className="mt-8 flex lg:mt-0 lg:flex-shrink-0">
              <div className="inline-flex rounded-md shadow">
                <a
                  href="#"
                  className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-orange-600 hover:bg-orange-700"
                >
                  Yes! I want it.
                </a>
              </div>
            </div>
          </div>
        </div>

      <Team/>

    </React.Fragment>
    
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my

  const profile = state && state.my && state.my.profile  || localStorage.getItem('userData') && JSON.parse(localStorage.getItem('userData'))


  const userInList = state.createAccount && state.createAccount.inList && state.createAccount.inList.find(item => item == 10) || window.location.search.includes("view=true")
  const userGotPreviousGuide = state.createAccount && state.createAccount.inList && state.createAccount.inList.find(item => item == 5)

  return {
    userInList,
    userGotPreviousGuide,
    profile
    // showSidebar: state.sidebar.show,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  contactInList: (data) => dispatch(CREATEACCOUNTACTIONS.contactInList(data)),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PayrollGuide) 
